import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Input from '../../../components/ui/Input';

const CryptoSelector = ({ cryptoList, selectedCrypto, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCryptos = cryptoList?.filter(crypto =>
    crypto?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    crypto?.symbol?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleSelect = (crypto) => {
    onSelect(crypto);
    setIsOpen(false);
    setSearchQuery('');
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 px-4 py-3 bg-card border border-border rounded-lg hover:bg-muted/50 transition-colors w-full md:w-auto"
      >
        <Image
          src={selectedCrypto?.icon}
          alt={selectedCrypto?.iconAlt}
          className="w-8 h-8 rounded-full"
        />
        <div className="flex-1 text-left">
          <div className="flex items-center gap-2">
            <span className="text-sm md:text-base font-semibold text-foreground">
              {selectedCrypto?.name}
            </span>
            <span className="text-xs md:text-sm text-muted-foreground">
              {selectedCrypto?.symbol}
            </span>
          </div>
          <div className="flex items-center gap-2 mt-0.5">
            <span className="text-xs md:text-sm font-medium text-foreground">
              ${selectedCrypto?.price?.toLocaleString()}
            </span>
            <span className={`text-xs font-medium ${selectedCrypto?.change >= 0 ? 'text-success' : 'text-error'}`}>
              {selectedCrypto?.change >= 0 ? '+' : ''}{selectedCrypto?.change}%
            </span>
          </div>
        </div>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={20} />
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-lg z-50 max-h-96 overflow-hidden flex flex-col">
            <div className="p-3 border-b border-border">
              <Input
                type="search"
                placeholder="Search cryptocurrency..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
              />
            </div>

            <div className="overflow-y-auto flex-1">
              {filteredCryptos?.length > 0 ? (
                filteredCryptos?.map((crypto) => (
                  <button
                    key={crypto?.id}
                    onClick={() => handleSelect(crypto)}
                    className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors ${
                      selectedCrypto?.id === crypto?.id ? 'bg-muted' : ''
                    }`}
                  >
                    <Image
                      src={crypto?.icon}
                      alt={crypto?.iconAlt}
                      className="w-8 h-8 rounded-full flex-shrink-0"
                    />
                    <div className="flex-1 text-left min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold text-foreground truncate">
                          {crypto?.name}
                        </span>
                        <span className="text-xs text-muted-foreground flex-shrink-0">
                          {crypto?.symbol}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 mt-0.5">
                        <span className="text-xs font-medium text-foreground">
                          ${crypto?.price?.toLocaleString()}
                        </span>
                        <span className={`text-xs font-medium ${crypto?.change >= 0 ? 'text-success' : 'text-error'}`}>
                          {crypto?.change >= 0 ? '+' : ''}{crypto?.change}%
                        </span>
                      </div>
                    </div>
                    {selectedCrypto?.id === crypto?.id && (
                      <Icon name="Check" size={20} color="var(--color-primary)" />
                    )}
                  </button>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center py-8 text-center">
                  <Icon name="Search" size={48} color="var(--color-muted-foreground)" />
                  <p className="text-sm text-muted-foreground mt-3">No cryptocurrencies found</p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CryptoSelector;